module.exports = __webpack_public_path__ + "static/media/003-pin.3fd93c69.svg";